/* settings */


const SETTINGS = Object.freeze({
  'url': {
    'observations': `${process.env['REACT_APP_OBSERVATIONS_DATA_BASE_URL']}`
  }
});

export default SETTINGS;